import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'OmniCredit me ayudó a mejorar mi puntaje en solo 3 meses',
  author: 'María G.'
}, {
  text: 'Excelente servicio, muy profesionales y claros',
  author: 'Carlos R.'
}, {
  text: 'Gracias a ellos pude comprar mi primera casa',
  author: 'Ana L.'
}, {
  text: 'El mejor servicio de crédito que he encontrado',
  author: 'Roberto M.'
}, {
  text: 'Me explicaron todo paso a paso, muy recomendados',
  author: 'Laura S.'
}, {
  text: 'Subí mi puntaje más de 100 puntos',
  author: 'Diego P.'
}];
export function SocialProofBar() {
  return <div className="bg-[#151C24] border-b border-slate-800/50 py-3 overflow-hidden relative flex items-center" data-id="element-102">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `
    }} data-id="element-103" />

      <div className="flex whitespace-nowrap animate-marquee w-max" data-id="element-104">
        {/* First set of reviews */}
        <div className="flex items-center gap-12 px-6" data-id="element-105">
          {reviews.map((review, idx) => <div key={`a-${idx}`} className="flex items-center gap-3 text-sm" data-id="element-106">
              <div className="flex items-center gap-0.5" data-id="element-107">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-omni fill-omni" data-id="element-108" />)}
              </div>
              <span className="text-slate-300 font-medium" data-id="element-109">
                "{review.text}"
              </span>
              <span className="text-slate-500" data-id="element-110">— {review.author}</span>
            </div>)}
        </div>
        {/* Duplicate set for seamless loop */}
        <div className="flex items-center gap-12 px-6" data-id="element-111">
          {reviews.map((review, idx) => <div key={`b-${idx}`} className="flex items-center gap-3 text-sm" data-id="element-112">
              <div className="flex items-center gap-0.5" data-id="element-113">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-omni fill-omni" data-id="element-114" />)}
              </div>
              <span className="text-slate-300 font-medium" data-id="element-115">
                "{review.text}"
              </span>
              <span className="text-slate-500" data-id="element-116">— {review.author}</span>
            </div>)}
        </div>
      </div>
    </div>;
}